import type { ModifiersType } from '@utils';
import { createClsNameMap, mergeModifiers } from '@utils';

export const clsNameMap = createClsNameMap({
  elements: {
    spin: createClsNameMap(),
  },
  modifiers: ['has-shadow', 'fixed'],
})('loading-icon');

export type LoadingIconProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  modifiers?: ModifiersType<typeof clsNameMap, true>;
};

export const LoadingIcon = ({ modifiers, ...attrs }: LoadingIconProps) => {
  return (
    <div className={mergeModifiers(clsNameMap, [modifiers])} {...attrs}>
      <span className={clsNameMap.elm('spin')}></span>
    </div>
  );
};
